import { ReactNode, createContext, useState, useEffect } from 'react';
// hooks
import useResponsive from '../hooks/useResponsive';
// ----------------------------------------------------------------------

export type CollapseDrawerContextProps = {
  isCollapse?: boolean;
  collapseClick: boolean;
  collapseHover: boolean;
  onToggleCollapse: VoidFunction;
  onHoverEnter: VoidFunction;
  onHoverLeave: VoidFunction;
  onLockCollapse: (locked: boolean) => void;
};

const initialState: CollapseDrawerContextProps = {
  collapseClick: false,
  collapseHover: false,
  onToggleCollapse: () => { },
  onHoverEnter: () => { },
  onHoverLeave: () => { },
  onLockCollapse: () => { }
};

const CollapseDrawerContext = createContext(initialState);

type CollapseDrawerProviderProps = {
  children: ReactNode;
};


function CollapseDrawerProvider({ children }: CollapseDrawerProviderProps) {

  var url = window.location?.href
  var params = url?.split('/');
  var checkURL = params[4]?.split("?")

  const isDesktop = useResponsive('up', 'lg');

  const [collapse, setCollapse] = useState({
    click: false,
    hover: false
  });

  // Set by a page (e.g. Ask Dost full screen) that needs the navbar to stay
  // collapsed for as long as it's mounted, without touching NavbarVertical
  // itself. Cleared again when that page unmounts.
  const [forceLock, setForceLock] = useState(false);

  useEffect(() => {
    // if (!isDesktop && checkURL && checkURL[0] === "formvalidation") {
    //   setCollapse({
    //     click: true,
    //     hover: false
    //   });
    // } else 
    if (!isDesktop) {
      setCollapse({
        click: false,
        hover: false
      });
    }
  }, [isDesktop]);

  const handleToggleCollapse = () => {
    if (forceLock) return;
    setCollapse({ ...collapse, click: !collapse.click });
  };

  const handleHoverEnter = () => {
    if (forceLock) return;
    if (collapse.click) {
      setCollapse({ ...collapse, hover: true });
    }
  };

  const handleHoverLeave = () => {
    setCollapse({ ...collapse, hover: false });
  };

  const handleLockCollapse = (locked: boolean) => {
    setForceLock(locked);
  };

  return (
    <CollapseDrawerContext.Provider
      value={{
        isCollapse: forceLock || (collapse.click && !collapse.hover),
        collapseClick: collapse.click,
        collapseHover: collapse.hover,
        onToggleCollapse: handleToggleCollapse,
        onHoverEnter: handleHoverEnter,
        onHoverLeave: handleHoverLeave,
        onLockCollapse: handleLockCollapse
      }}
    >
      {children}
    </CollapseDrawerContext.Provider>
  );
}

export { CollapseDrawerProvider, CollapseDrawerContext };
